import { render, staticRenderFns } from "./OutlinedTextarea.vue?vue&type=template&id=3797d98c&scoped=true&"
import script from "./OutlinedTextarea.vue?vue&type=script&lang=ts&"
export * from "./OutlinedTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./OutlinedTextarea.vue?vue&type=style&index=0&id=3797d98c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3797d98c",
  null
  
)

export default component.exports